import { render } from "./Heading.vue?vue&type=template&id=596a4a4e&scoped=true"
import script from "./Heading.vue?vue&type=script&lang=js"
export * from "./Heading.vue?vue&type=script&lang=js"

import "./Heading.vue?vue&type=style&index=0&id=596a4a4e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-596a4a4e"

export default script